module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-kpito-intro-card1.2@2x.f4c2ed1a.jpg";